var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('i',{staticClass:"iconetitulo",class:_vm.classeAwesome,attrs:{"aria-hidden":"true"}}),_c('h2',{attrs:{"id":"titulo"}},[_vm._v(_vm._s(_vm.nome))]),_c('div',{attrs:{"id":"linhadivisoria"}})])}
var staticRenderFns = []

export { render, staticRenderFns }